module.exports = __webpack_public_path__ + "img/iq.1c6a52f2.svg";